<template>
    <div v-if="userId" class="mx-auto bg-gray-600 flex flex-nowrap whitespace-nowrap px-4 sm:px-6 lg:px-8 h-10 space-x-8">
        <NavLink v-for="r in routes" v-show="r.show" :href="r.route" :active="r.active">{{ r.name }}</NavLink>
    </div>
</template>

<script>
import NavLink from "@/Components/NavLink";

export default {
    components: {
        NavLink,
    },
    props: {
        userId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            routes: [
                {
                    name: 'К списку',
                    route: this.route('ocp.users'),
                    active: this.route().current('ocp.users'),
                    show: true,
                },
                {
                    name: 'Пользователь',
                    route: this.route('ocp.user', this.userId),
                    active: this.route().current('ocp.user'),
                    show: true,
                },
                {
                    name: 'Онлайн сессии',
                    route: this.route('user.sessions.online', this.userId),
                    active: this.route().current('user.sessions.online'),
                    show: this.access('user', 'sessions'),
                },
                {
                    name: 'Организации',
                    route: this.route('user.organizations', this.userId),
                    active: this.route().current('user.organizations'),
                    show: this.access('organizations', 'available'),
                },
                {
                    name: 'Рефералы',
                    route: this.route('user.referrals', this.userId),
                    active: this.route().current('user.referrals'),
                    show: this.access('referrals', 'available'),
                },
            ],
        }
    },
}
</script>
